/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { readable_holder } from '../models/readable_holder';
import type { readable_member } from '../models/readable_member';
import type { retailer } from '../models/retailer';
import type { writtable_holder } from '../models/writtable_holder';
import type { writtable_member } from '../models/writtable_member';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HolderService {
    /**
     * Test if holder ref is valid for C-wallet.
     *
     * @param ref
     * @returns any Successful operation, returning holder reference validation.
     * @throws ApiError
     */
    public static getHolderValidation(
        ref: string,
    ): CancelablePromise<{
        /**
         * retailers for which holder ref is valid.
         */
        retailers?: Array<retailer>;
        /**
         * boolean to know if this holder ref  already exists or not.
         */
        exists?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/holder_validation',
            query: {
                'ref': ref,
            },
        });
    }
    /**
     * Create a C-wallet `Member`.
     *
     * @param member
     * @returns readable_member Successful operation, returning created member.
     * @throws ApiError
     */
    public static postMembers(
        member: writtable_member,
    ): CancelablePromise<readable_member> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members',
            body: member,
        });
    }
    /**
     * Update C-wallet `Member` information.
     *
     * @param memberId Member identifier
     * @param member
     * @returns readable_member Successful operation, returning saved member.
     * @throws ApiError
     */
    public static patchMembers(
        memberId: number,
        member: writtable_member,
    ): CancelablePromise<readable_member> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/members/{member_id}',
            path: {
                'member_id': memberId,
            },
            body: member,
        });
    }
    /**
     * Get list of  `Holder` (loyalty card) for a member.
     *
     * @param memberId Member identifier
     * @param ignoreRef skip details or not
     * @returns readable_holder Successful operation, returning found `Holders` (loyalty card).
     * @throws ApiError
     */
    public static getMembersHolders(
        memberId: number,
        ignoreRef?: boolean,
    ): CancelablePromise<Array<readable_holder>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/members/{member_id}/holders',
            path: {
                'member_id': memberId,
            },
            query: {
                'ignore_ref': ignoreRef,
            },
        });
    }
    /**
     * Create a `Holder` (loyalty card) for a member.
     *
     * @param memberId Member identifier
     * @param holder
     * @returns readable_holder Successful operation, returning created holder.
     * @throws ApiError
     */
    public static postMembersHolders(
        memberId: number,
        holder: writtable_holder,
    ): CancelablePromise<readable_holder> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/members/{member_id}/holders',
            path: {
                'member_id': memberId,
            },
            body: holder,
        });
    }
    /**
     * Update a `Holder` (loyalty card) for a member.
     *
     * @param memberId Member identifier
     * @param holderId Holder identifier
     * @param holder
     * @returns readable_holder Successful operation, returning updated holder.
     * @throws ApiError
     */
    public static patchMembersHolders(
        memberId: number,
        holderId: number,
        holder: writtable_holder,
    ): CancelablePromise<readable_holder> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/members/{member_id}/holders/{holder_id}',
            path: {
                'member_id': memberId,
                'holder_id': holderId,
            },
            body: holder,
        });
    }
    /**
     * Delete a `Holder` (loyalty card) of a member.
     *
     * @param memberId Member identifier
     * @param holderId Holder identifier
     * @returns any Successful operation
     * @throws ApiError
     */
    public static deleteMembersHolders(
        memberId: number,
        holderId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/members/{member_id}/holders/{holder_id}',
            path: {
                'member_id': memberId,
                'holder_id': holderId,
            },
        });
    }
}
